import * as React from "react"

import { SelectCameraInner } from "./SelectCameraInner"

export default class SelectCamera extends React.Component {

    render() {

        return <SelectCameraInner />
    }
}




// WEBPACK FOOTER //
// ./src/Routes/SelectCamera/SelectCamera.tsx